<template>
  <div class="login-card">
    <div class="card-header">
      <div class="avatar-container">
        <!-- Placeholder avatar or logo -->
         <div class="avatar-placeholder">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
         </div>
      </div>
      <div class="rating-badge">
        <span>Acesso Restrito</span>
      </div>
    </div>

    <form @submit.prevent="handleLogin" class="login-form">
      <div class="form-group">
        <label>E-mail</label>
        <div class="input-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
          <input type="email" v-model="email" required placeholder="admin@exemplo.com" />
        </div>
      </div>

      <div class="form-group">
        <label>Senha</label>
        <div class="input-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
          <input type="password" v-model="password" required placeholder="••••••••" />
        </div>
      </div>

      <div class="error-message" v-if="error">
        {{ error }}
      </div>

      <div class="actions">
        <button type="submit" :disabled="loading" class="btn-submit">
          <span v-if="!loading">Entrar</span>
          <div v-else class="spinner"></div>
        </button>
      </div>
    </form>
    <div class="card-footer">
      <p>OligoCheck &copy; {{ new Date().getFullYear() }}</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { auth } from '@/firebaseConfig';
import { signInWithEmailAndPassword } from 'firebase/auth';

const email = ref('');
const password = ref('');
const error = ref('');
const loading = ref(false);
const router = useRouter();

const handleLogin = async () => {
  loading.value = true;
  error.value = '';
  
  try {
    await signInWithEmailAndPassword(auth, email.value, password.value);
    router.push('/admin/dashboard');
  } catch (e) {
    console.error(e);
    if (e.code === 'auth/invalid-credential' || e.code === 'auth/user-not-found' || e.code === 'auth/wrong-password') {
      error.value = 'Credenciais inválidas.';
    } else {
      error.value = 'Erro ao conectar. Tente novamente.';
    }
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.login-card {
  background: white;
  border-radius: 32px;
  padding: 40px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
}

.card-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  width: 100%;
}

.avatar-container {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #f0f7ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  border: 4px solid #fff;
  box-shadow: 0 8px 20px rgba(0,0,0,0.06);
}

.avatar-placeholder {
  color: var(--cor-azul);
}

h2 {
  font-family: var(--bold);
  color: var(--cor-escuro-1);
  font-size: 22px;
  margin: 0 0 8px 0;
}

.rating-badge {
  background: #fff8e1;
  border: 1px solid #ffeeba;
  padding: 4px 12px;
  border-radius: 20px;
  color: #d97706;
  font-size: 12px;
  font-family: var(--bold);
  display: flex;
  align-items: center;
  gap: 4px;
}

.login-form {
  width: 100%;
}

.form-group {
  margin-bottom: 20px;
  text-align: left;
}

label {
  display: block;
  font-size: 12px;
  font-family: var(--bold);
  color: var(--cor-escuro-2);
  margin-bottom: 8px;
  margin-left: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.input-wrapper {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.2s ease;
}

.input-wrapper:focus-within {
  background: #fff;
  border-color: var(--cor-azul);
  box-shadow: 0 0 0 4px rgba(34, 128, 180, 0.1);
}

.input-wrapper svg {
  color: #94a3b8;
}

.input-wrapper:focus-within svg {
  color: var(--cor-azul);
}

input {
  border: none;
  background: transparent;
  width: 100%;
  font-size: 15px;
  color: var(--cor-escuro-1);
  outline: none;
  font-family: var(--regular);
}

.actions {
  margin-top: 10px;
}

.btn-submit {
  width: 100%;
  background: var(--cor-azul);
  color: white;
  border: none;
  padding: 16px;
  border-radius: 16px;
  font-family: var(--bold);
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 15px rgba(34, 128, 180, 0.25);
}

.btn-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(34, 128, 180, 0.35);
}

.btn-submit:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
  box-shadow: none;
}

.error-message {
  color: #ef4444;
  font-size: 13px;
  margin-bottom: 16px;
  background: #fef2f2;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #fee2e2;
}

.card-footer {
  margin-top: 30px;
  color: #94a3b8;
  font-size: 12px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 0.8s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>

